
import {Component, Prop, Ref, Vue, Watch} from "vue-property-decorator";
import {sancionStore} from "@/store/sancionStore";
import {http} from "@/config/HttpClient";
import {DateTime} from "luxon";
import {MaterialService} from "@/services/MaterialService";
import {Alert} from "@/addons/Alert";
import InputUnsignedDecimal from "../../components/InputUnsignedDecimal.vue";
import InputUppercaseRequired from "../../components/InputUppercaseRequired.vue";
import InputUppercase from "../../components/InputUppercase.vue";
import {materialStore} from "@/store/materialStore";
import {IngresoService} from "@/services/IngresoService";
import {SalidaService} from "@/services/SalidaService";
import {ingresoStore} from "@/store/ingresoStore";
import {salidaStore} from "@/store/salidaStore";
import * as stream from "stream";

@Component({
  name: "valeGasolinaNew",
  components: {InputUnsignedDecimal, InputUppercaseRequired, InputUppercase},
})
export default class extends Vue {
  @Ref('fileInput') fileInput!: HTMLInputElement;

  sancion = {
    codigo: '',
    meses_plazo: 1,

  }

  @Prop() isNew!: boolean
  private iniciado = 'Iniciado'
  private materialStore = materialStore();
  private sancionStore = sancionStore();
  private salidaStore = salidaStore();
  private materialService = MaterialService.getInstance();
  private salidaService = SalidaService.getInstance();
  private fecha = DateTime.now().toFormat("yyyy-MM-dd");
  private headers = [
    {text: "Fecha", value: "fecha"},
    {text: "Acción", value: "accion"},
    {text: "Usuario", value: "user.email"}
  ];

  //search = null;
  files = null;
  validBuscar = false;
  valid = false;
  esEdiatr= false;
  selected_funcionario = null;
  selected_vehiculo = null;
  txtBuscar = '';
  cantidad= 1;
  cantidad_entregada= 1;
  precio_unitario= 1;
  isEdit = false;
  txtNroTramite = '';
  isLoading = false;
  swEditar = true;
  txtSearch = "";
  txtFuncionario = "";
  txtPlaca = "";
  valeGasolina = {
    id: '',
    numero_pedido: this.nuevoCodigoValeGasolina,
    fecha: DateTime.now().toFormat('yyyy-MM-dd'),
    observaciones: '',
    kilometraje: '',
    estacion_servicio_id: '',
    movilidad_id: '',
    centro_costos_id: '',
    litros_id: '',
    chofer_id: '',
    autoriza_id: '',
    tipo: ''
  };
  //clientes = [];
  materiales = [];
  funcionarios_all = [];
  vehiculos_all = [];

  public funcionario= {
    item: '',
    ci: '',
    nombre_completo: '',
    oficina: ''
  };

  public vehiculo= {
    id: '',
    placa: ''
  };
  private imageBase64: string | null = null;

  cliente_seleccionado = null;
  private cuenta = null;

  //private sancion = [];

  //private sancion = null;

  $refs!: {
    form: HTMLFormElement,
    txtCuenta: HTMLInputElement,
    montoRec: HTMLInputElement,
  };

  mounted(){
    this.getNuevoCodigoValeGasolina();
    this.getFuncionarioResponsable();
    this.getChoferResponsable();
    this.getEstacionServicio();
    this.getMovilidades();
    this.getCentroCostos();
    this.getLitros();
  }

  get litros(): any {
    return this.salidaStore.litros;
  }

  getLitros() {
    this.salidaService.getLitros();
  }

  get centroCostos(): any {
    return this.salidaStore.centroCostos;
  }

  getCentroCostos() {
    this.salidaService.getCentroCostos();
  }


  get movilidades(): any {
    return this.salidaStore.movilidades;
  }

  getMovilidades() {
    this.salidaService.getMovilidades();
  }

  get estacionServicio(): any {
    return this.salidaStore.estacionServicio;
  }

  getEstacionServicio() {
    this.salidaService.getEstacionServicio();
  }


  get choferResponsable(): any {
    return this.salidaStore.chofer_responsable;
  }

  getChoferResponsable() {
    this.salidaService.getChoferResponsable();
  }

  get funcionarioResponsable(): any {
    return this.salidaStore.funcionario_responsable;
  }

  getFuncionarioResponsable() {
    this.salidaService.getFuncionarioResponsable();
  }

  get valeSalidaMaterial(): any[] {
    return this.salidaStore.valeSalidaMaterial;
  }

  get nuevoValeGasolina(): any[] {
    return this.salidaStore.newValeGasolina;
  }

  getFuncionarios(value:string){
    this.loading
    this.salidaService.getFuncionarios(value)
  }

  getVehiculos(value:string){
    this.loading
    this.salidaService.getVehiculos(value)
  }

  get vehiculos(): any{
    return this.salidaStore.movilidades;
  }
  get funcionarios(): any {
    return this.salidaStore.funcionarios;
  }

  seleccionFuncionario(){
    console.log(this.selected_vehiculo)
    if(this.selected_vehiculo !== null){
      this.valeGasolina.centro_costos_id= this.selected_vehiculo.centro_costos_id
      this.valeGasolina.chofer_id= this.selected_vehiculo.responsable_id
      this.vehiculo= {
        id: this.selected_vehiculo.id,
        placa: this.selected_vehiculo.placa
      }
    }else
      this.limpiar()

  }

  limpiar() {
    this.funcionario = {
      item: '',
      ci: '',
      nombre_completo: ''
    }
  }


  get loading(): boolean {
    return this.materialStore.loading;
  }


  get nuevoCodigoValeGasolina(): string {
    return this.salidaStore.nuevoCodigoValeGasolina;
  }

  getNuevoCodigoValeGasolina(){
    this.salidaService.getNuevoCodigoValeGasolina()
  }

  getMateriales(value:string) {
    this.loading;
    this.materialService.getMateriales(value);
  }

  @Watch('txtPlaca')
  searchPlaca(value: string) {
    if(value != null && value.length > 1){
      this.$nextTick().then( () => {
        this.getVehiculos(value);
      })

      this.vehiculos_all = this.salidaStore.movilidades;

    }
  }

  @Watch('txtFuncionario')
  searchFuncionario(value: string) {
    if(value != null && value.length > 1){
      this.$nextTick().then( () => {
        this.getFuncionarios(value);
      })

      this.funcionarios_all = this.salidaStore.funcionarios;

    }
  }

  @Watch('txtSearch')
  search(value: string) {
    if (value != null && value.length > 2) {
      this.$nextTick().then(() => {
        this.getMateriales(value);
      })
    }
  }
  guardar(){
    if (!this.$refs.form.validate()) {
      return;
    }
    Alert.confirm(`Guardar el Vale de Salida del Funcionario: <br>
                    ${this.funcionario.nombre_completo}`
    ).then(res => {
      if (res.isConfirmed) {

        if (this.nuevoValeGasolina.length !== 0){
          const data = {
            valeGasolinaId: this.nuevoValeGasolina.id, valeGasolina:this.valeGasolina, vehiculo: this.vehiculo
          }
          this.salidaService.updateValeGasolina(data);
        }

        else {
          const data = {valeGasolina:this.valeGasolina, codigo:this.nuevoCodigoValeGasolina, vehiculo: this.vehiculo}
          this.salidaService.saveValeGasolina(data);
        }


        this.$emit('listar')
      }
    })
  }

  imprimir(id:number){
    if (id === undefined){
      Alert.error('Primero guarde el vale de Gasolina')
      return false
    }
      this.salidaService.imprimirValeGasolina(id);

  }

  private handleFileChange(): void {
    const files = this.fileInput.files;
    if (files && files.length > 0) {
      const reader = new FileReader();
      reader.onload = () => {
        this.imageBase64 = reader.result as string;
      };
      reader.readAsDataURL(files[0]);
    }
  }


  private uploadImage(): void {
    if (!this.imageBase64) {
      alert('Por favor selecciona una imagen.');
      return;
    }

    const data = {image: this.imageBase64, id: this.nuevoValeGasolina.id}

    this.salidaService.adjuntarImagenValeGasolina(data);
  }
}
